import { useNavigate } from 'react-router-dom';
import IconEdit from '../../../../../../components/icons/icon-edit/icon-edit';
import { ButtonIcon } from '../../../../../../components/inputs/button-icon/button-icon';

interface EditApiKeyButtonProps {
    integrationsConnectionId: number;
    isDisabled: boolean;
}

const EditApiKeyButton: React.FC<EditApiKeyButtonProps> = ({ integrationsConnectionId, isDisabled }) => {
    let navigate = useNavigate();
    const handleClick = () => {
        navigate({
            pathname: integrationsConnectionId.toString()
        });
    };

    return (
        <ButtonIcon Component={IconEdit} onClick={handleClick} disabled={isDisabled} />
    );
};

export default EditApiKeyButton;
